var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox relative" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:draw:JoinRecord:list"],
            expression: "['platform:draw:JoinRecord:list']",
          },
        ],
      },
      [
        _c(
          "el-card",
          {
            staticClass: "ivu-mt",
            attrs: {
              bordered: false,
              shadow: "never",
              "body-style": { padding: 0 },
            },
          },
          [
            _c(
              "div",
              { staticClass: "padding-add" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: "",
                      size: "small",
                      "label-position": "right",
                    },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "活动编号：" } },
                      [
                        _c("el-input", {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入活动编号",
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery($event)
                            },
                          },
                          model: {
                            value: _vm.queryParams.activityId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "activityId",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "queryParams.activityId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "用户ID：" } },
                      [
                        _c("el-input", {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请输入用户ID", clearable: "" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery($event)
                            },
                          },
                          model: {
                            value: _vm.queryParams.userId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "userId",
                                _vm._n(
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              )
                            },
                            expression: "queryParams.userId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "手机号：" } },
                      [
                        _c("el-input", {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请输入手机号", clearable: "" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery($event)
                            },
                          },
                          model: {
                            value: _vm.queryParams.phoneNumber,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "phoneNumber",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "queryParams.phoneNumber",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "兑奖码：" } },
                      [
                        _c("el-input", {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请输入兑奖码", clearable: "" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery($event)
                            },
                          },
                          model: {
                            value: _vm.queryParams.redeemCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "redeemCode",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "queryParams.redeemCode",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品状态：" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请选择奖品状态",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryParams.winStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "winStatus", $$v)
                              },
                              expression: "queryParams.winStatus",
                            },
                          },
                          _vm._l(_vm.winStatusOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "用户类型：" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请选择用户类型",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryParams.userType,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "userType", $$v)
                              },
                              expression: "queryParams.userType",
                            },
                          },
                          _vm._l(_vm.userTypeOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "时间范围：" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "380px" },
                          attrs: {
                            type: "daterange",
                            "value-format": "yyyy-MM-dd",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            clearable: "",
                          },
                          on: { change: _vm.handleDateChange },
                          model: {
                            value: _vm.dateRange,
                            callback: function ($$v) {
                              _vm.dateRange = $$v
                            },
                            expression: "dateRange",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.handleQuery },
                          },
                          [_vm._v("查询")]
                        ),
                        _c("el-button", { on: { click: _vm.resetQuery } }, [
                          _vm._v("重置"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _c(
          "el-card",
          {
            staticClass: "table-card mt14",
            attrs: { "body-style": { padding: "20px" } },
          },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.recordList, size: "small" },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "recordId",
                    label: "记录ID",
                    align: "center",
                    width: "100",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "activityId",
                    label: "活动编号",
                    align: "center",
                    width: "100",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "activityName",
                    label: "活动名称",
                    "show-overflow-tooltip": true,
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "activityTime",
                    label: "活动时间",
                    width: "160",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "drawTime", label: "抽奖时间", width: "160" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "expireTime",
                    label: "过期时间",
                    width: "160",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "awardName",
                    label: "奖项名称",
                    "show-overflow-tooltip": true,
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "prizeName",
                    label: "奖品名称",
                    "show-overflow-tooltip": true,
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "prizeType", label: "奖品类型", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.formatPrizeType(scope.row.prizeType))
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "redeemCode",
                    label: "兑奖码",
                    width: "100",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "redPacketPrice",
                    label: "红包金额",
                    width: "100",
                    align: "right",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "winStatus",
                    label: "奖品状态",
                    width: "100",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.getWinStatusTag(scope.row.winStatus),
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatWinStatus(scope.row.winStatus)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "userId", label: "用户ID", width: "80" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "userType",
                    label: "用户类型",
                    width: "100",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  scope.row.userType === 1 ? "success" : "info",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatUserType(scope.row.userType)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { width: "120", fixed: "right", label: "操作" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.userType === 1 && row.winStatus === 2
                            ? [
                                _vm.checkPermi([
                                  "platform:draw:JoinRecord:updateStatus",
                                ])
                                  ? [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "mr10",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDelivery(row)
                                            },
                                          },
                                        },
                                        [_vm._v("发放")]
                                      ),
                                    ]
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("el-pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.total > 0,
                  expression: "total > 0",
                },
              ],
              attrs: {
                background: "",
                "current-page": _vm.queryParams.page,
                "page-size": _vm.queryParams.limit,
                "page-sizes": [10, 20, 30, 50],
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.queryParams, "page", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.queryParams, "page", $event)
                },
                "update:pageSize": function ($event) {
                  return _vm.$set(_vm.queryParams, "limit", $event)
                },
                "update:page-size": function ($event) {
                  return _vm.$set(_vm.queryParams, "limit", $event)
                },
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }